import { render, staticRenderFns } from "./LaDSection.vue?vue&type=template&id=3e8bac61&"
import script from "./LaDSection.vue?vue&type=script&lang=js&"
export * from "./LaDSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports